import { useEffect, useState } from 'react';

/**
 * Общий поиск с дебаунсом — используется в панелях тестов/цен (карточка
 * клиента и мастер создания): возвращает [дебаунсенное значение, сырой
 * инпут, сеттер инпута].
 */
export function useDebouncedSearch(): [string, string, (v: string) => void] {
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setSearch(searchInput.trim()), 300);
    return () => clearTimeout(timer);
  }, [searchInput]);

  return [search, searchInput, setSearchInput];
}
